import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-290976d3")

_pushScopeId("data-v-290976d3")
const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "pi pi-file" }, null, -1)
const _hoisted_2 = { class: "p-m-2" }
const _hoisted_3 = {
  key: 0,
  class: "pi pi-exclamation-triangle kn-warning-icon",
  "data-test": "warning-icon"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "p-m-2" }
const _hoisted_6 = { class: "kn-material-input-label" }
const _hoisted_7 = { class: "p-d-flex p-flex-row p-jc-between" }
const _hoisted_8 = { class: "name-help p-m-0" }
const _hoisted_9 = { class: "p-m-2" }
const _hoisted_10 = { class: "kn-material-input-label" }
const _hoisted_11 = { class: "p-d-flex p-jc-end" }
const _hoisted_12 = { class: "p-m-2" }
const _hoisted_13 = { class: "p-ml-2" }
const _hoisted_14 = {
  key: 0,
  class: "kn-flex p-mx-2 p-my-4"
}
const _hoisted_15 = { class: "kn-material-input-label" }
const _hoisted_16 = { class: "p-d-flex p-jc-end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_AccordionTab = _resolveComponent("AccordionTab")
  const _component_Accordion = _resolveComponent("Accordion")

  return (_openBlock(), _createBlock(_component_Accordion, { activeIndex: 0 }, {
    default: _withId(() => [
      _createVNode(_component_AccordionTab, null, {
        header: _withId(() => [
          _hoisted_1,
          _createVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('managers.scheduler.saveAsFile')), 1),
          (_ctx.document.invalid?.invalidFile)
            ? (_openBlock(), _createBlock("i", _hoisted_3))
            : _createCommentVNode("", true)
        ]),
        default: _withId(() => [
          (_ctx.document)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("span", null, [
                    _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('common.fileName')) + " *", 1),
                    _createVNode(_component_InputText, {
                      class: ["kn-material-input  p-inputtext-sm", {
                                'p-invalid': _ctx.fileNameDirty && (!_ctx.document.fileName || _ctx.document.fileName.length === 0)
                            }],
                      modelValue: _ctx.document.fileName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.document.fileName = $event)),
                      maxLength: _ctx.schedulerTimingOutputOutputTabDescriptor.accordion.file.nameMaxLength,
                      onInput: _ctx.setFileNameValidation,
                      onBlur: _ctx.setFileNameValidation
                    }, null, 8, ["modelValue", "class", "maxLength", "onInput", "onBlur"])
                  ]),
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", null, [
                      _withDirectives(_createVNode("div", { class: "p-error p-grid p-m-2" }, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('common.fileName') })), 513), [
                        [_vShow, _ctx.fileNameDirty && (!_ctx.document.fileName || _ctx.document.fileName.length === 0)]
                      ])
                    ]),
                    _createVNode("p", _hoisted_8, _toDisplayString(_ctx.fileNameHelp), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_9, [
                  _createVNode("span", null, [
                    _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('managers.scheduler.destinationFolder')), 1),
                    _createVNode(_component_InputText, {
                      class: "kn-material-input  p-inputtext-sm",
                      modelValue: _ctx.document.destinationfolder,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.document.destinationfolder = $event)),
                      maxLength: _ctx.schedulerTimingOutputOutputTabDescriptor.accordion.file.destinationFolderMaxLength
                    }, null, 8, ["modelValue", "maxLength"])
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _createVNode("small", null, _toDisplayString(_ctx.destinationFolderHelp), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode(_component_Checkbox, {
                    modelValue: _ctx.document.zipFileDocument,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.document.zipFileDocument = $event)),
                    binary: true
                  }, null, 8, ["modelValue"]),
                  _createVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('managers.scheduler.zipFileDocument')), 1)
                ]),
                (_ctx.document.zipFileDocument)
                  ? (_openBlock(), _createBlock("div", _hoisted_14, [
                      _createVNode("span", null, [
                        _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('managers.scheduler.zipFileName')), 1),
                        _createVNode(_component_InputText, {
                          class: "kn-material-input p-inputtext-sm",
                          modelValue: _ctx.document.zipFileName,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.document.zipFileName = $event)),
                          maxLength: _ctx.schedulerTimingOutputOutputTabDescriptor.accordion.file.zipFileNameMaxLength
                        }, null, 8, ["modelValue", "maxLength"])
                      ]),
                      _createVNode("div", _hoisted_16, [
                        _createVNode("small", null, _toDisplayString(_ctx.zipFileNameHelp), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})